import { SvgIcon } from "@mui/material";

export default function PackageBrowserIcon() {
	return (
		<SvgIcon fontSize="small">
			<path
				d="M 14.5,0 H 1 C 0.448,0 0,0.448 0,1 v 13.5 c 0,0.552 0.448,1 1,1 h 13.5 c 0.552,0 1,-0.448 1,-1 V 1 c 0,-0.552 -0.448,-1 -1,-1 z"
				id="path2"
			/>
			<path
				d="M 15.5,17 H 1 c -0.552,0 -1,0.448 -1,1 v 5 c 0,0.552 0.448,1 1,1 h 22 c 0.552,0 1,-0.448 1,-1 v -5 c 0,-0.552 -0.448,-1 -1,-1 h -6 z"
				id="path4"
			/>
			<path
				d="m 23,0 h -5 c -0.552,0 -1,0.448 -1,1 v 13.5 c 0,0.552 0.448,1 1,1 h 5 c 0.552,0 1,-0.448 1,-1 V 1 C 24,0.448 23.552,0 23,0 Z"
				id="path6"
			/>
		</SvgIcon>
	);
}
